import React, { Component } from "react";
import ReactLoading from "react-loading";

import SideBar from "./SideBar";

import MuiThemeProvider from "material-ui/styles/MuiThemeProvider";
import AppBar from 'material-ui/AppBar';
import IconButton from 'material-ui/IconButton'
import { LogoutIcon, MenuIcon } from '@heroicons/react/outline'

// Screens
import AdminDashboard from "./AdminDashboard";

import Users from "./Users";
import UserForm from "./Users/UserForm";

import Students from "./Students";

import AdminAdmissionAlerts from "./AdminAdmissionAlerts";
import AdminAdmissionAlertDetails from "./AdminAdmissionAlerts/AdminAdmissionAlertDetails";

import AdminScholarshipAlerts from './AdminScholarshipAlerts'
import AdminScholarshipAlertDetails from "./AdminScholarshipAlerts/AdminScholarshipAlertDetails";
import AdminScholarshipAlertForm from "./AdminScholarshipAlerts/AdminScholarshipAlertForm";

import AdminCareers from "./AdminCareers";
import AdminCareerDetails from "./AdminCareers/AdminCareerDetails";
import AdminCareerForm from "./AdminCareers/AdminCareerForm";

import UniversityMaster from "./UniversityMaster";
import UniversityMasterForm from "./UniversityMaster/UniversityMasterForm";
import SchoolCode from "./SchoolCode";
import SchoolCodeForm from "./SchoolCode/SchoolCodeForm";



import LiveAdvertisement from "./LiveAdvertisement";

import "./style.css"

class Admin extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: window.innerWidth < 980 ? false : true,
      type: 0,
      routePage: 'dashboard',
      _type: null,
      detail: false,
      id: null,
      title: "",
      description: "",
      message: "",
      studentData: "",
      isAdmin: 1,
      show: false,
      details: {},
      activeThis: null,
      selectedObject: null,
      showLoading: true,
      detailsData: null,
      vWidth: null
    }
  }

  componentWillUnmount() {
    localStorage.setItem("isLogin", 0);
    localStorage.setItem("isAdminLogin", false);
    window.removeEventListener('resize', this.updateWindowDimensions)
  }

  componentDidMount() {
    this.updateWindowDimensions();
    window.addEventListener('resize', this.updateWindowDimensions)
    setTimeout(() => {
      let obj = localStorage.getItem("userType");
      let isLogin = localStorage.getItem("isAdminLogin");
      if (isLogin == true) {
        this.setState({ showLoading: false, isAdmin: obj });
      } else {
        if (isLogin == "true") {
          this.setState({ showLoading: false, isAdmin: obj });
        } else {
          this.props.router.push("/signIn");
        }
      }
    }, 1500);
  }

  updateWindowDimensions = () => {
    this.setState({ vWidth: window.innerWidth });
  }

  updateRoutePage = (routePage) => {
    const { vWidth } = this.state
    this.setState({ routePage, detailsData: null })
    vWidth < 980 && this.setState({ isOpen: false })
  }

  showDetails = (routePage, detailsData) => this.setState({ routePage, detailsData })

  logoutUser = () => {
    localStorage.setItem("isAdminLogin", false);
    this.props.router.push("/");
  }

  toggleSidebar = () => {
    this.setState(state => ({ isOpen: !state.isOpen }))
  }

  handleRequestChange = (isOpen) => {
    this.setState({ isOpen })
  }

  render() {
    const {
      isOpen,
      routePage,
      detailsData
    } = this.state

    const routes = {
      'dashboard': 'Dashboard',
      'users': 'Users',
      'user-form': 'User',
      'students': 'Students',
      'admn-alerts': 'Admission Alerts',
      'admn-alert-details': 'Admission Alert Details',
      'scholarship-alerts': 'Scholarship Alerts',
      'scholarship-alert-details': 'Scholarship Alert Details',
      'new-scholarship-alerts': 'Scholarship Alert',
      'careers': 'Careers',
      'career-details': 'Career Details',
      'new-career': 'Career',
      'university': 'University Master',
      'university-form': 'University',
      'school-code':'School Code',
      'school-code-form':'School Code Form',
      'advertisement': 'Live Advertisement'
    }

    return (
      <MuiThemeProvider>
        <div className="dash-container">
          <SideBar
            isOpen={isOpen}
            handleRequestChange={this.handleRequestChange}
            routePage={routePage}
            updateRoutePage={this.updateRoutePage}
          />

          <div className="dash-content">
            <AppBar
              title={routes[routePage]}
              className="dash-app-bar"
              iconElementLeft={
                <IconButton className="menu-toggler" onClick={this.toggleSidebar}>
                  <MenuIcon className='text-light' />
                </IconButton>
              }
              iconElementRight={
                <IconButton onClick={this.logoutUser} tooltip="Logout">
                  <LogoutIcon className='text-dark logout-icon' />
                </IconButton>
              }
            />
            <div className="container">
              {routePage === 'dashboard' && <AdminDashboard updateRoutePage={this.updateRoutePage} />}
              {routePage === 'users' && <Users showDetails={this.showDetails} updateRoutePage={this.updateRoutePage} />}
              {routePage === 'user-form' && <UserForm data={detailsData} updateRoutePage={this.updateRoutePage} />}
              {routePage === 'students' && <Students showDetails={this.showDetails} updateRoutePage={this.updateRoutePage} />}
              {routePage === 'admn-alerts' && <AdminAdmissionAlerts showDetails={this.showDetails} />}
              {routePage === 'admn-alert-details' && <AdminAdmissionAlertDetails data={detailsData} updateRoutePage={this.updateRoutePage} />}
              {routePage === 'scholarship-alerts' && <AdminScholarshipAlerts showDetails={this.showDetails} updateRoutePage={this.updateRoutePage} />}
              {routePage === 'scholarship-alert-details' && <AdminScholarshipAlertDetails data={detailsData} updateRoutePage={this.updateRoutePage} />}
              {routePage === 'new-scholarship-alerts' && <AdminScholarshipAlertForm data={detailsData} updateRoutePage={this.updateRoutePage} />}
              {routePage === 'careers' && <AdminCareers showDetails={this.showDetails} updateRoutePage={this.updateRoutePage} />}
              {routePage === 'career-details' && <AdminCareerDetails data={detailsData} updateRoutePage={this.updateRoutePage} />}
              {routePage === 'new-career' && <AdminCareerForm data={detailsData} updateRoutePage={this.updateRoutePage} />}
              {routePage === 'university' && <UniversityMaster showDetails={this.showDetails} updateRoutePage={this.updateRoutePage} />}
              {routePage === 'university-form' && <UniversityMasterForm data={detailsData} updateRoutePage={this.updateRoutePage} />}
              {routePage === 'school-code' && <SchoolCode showDetails={this.showDetails} updateRoutePage={this.updateRoutePage} />}
              {routePage === 'school-code-form' && (
                <SchoolCodeForm   key={detailsData.id || 'new'} 
                data={detailsData || {}}                   
                    updateRoutePage={this.updateRoutePage}
                  />
                )}

            
              {routePage === 'advertisement' && <LiveAdvertisement showDetails={this.showDetails} updateRoutePage={this.updateRoutePage} />}
            </div>
          </div>
        </div>
      </MuiThemeProvider>
    )
  }
}

export default Admin



/** WEBPACK FOOTER **
 ** ./src/components/Admin/index.js
 **/